<template>
  <div v-if="opened" class="offer-modal layer survey-layer">
    <div class="layer-container">
      <div
        class="layer-content flex flex-col justify-center items-center"
        v-click-outside="close"
      >
        <img src="@/assets/offie-logo-black.svg" />
        <h2 v-show="!success" class="mt-3 lg:text-lg text-center text-md">
          Visszatérünk hozzád a kiválasztott irodaházakban elérhető területekkel
        </h2>

        <h2 v-show="success" class="text-center text-base">
          Köszönjük, hamarosan felvesszük veled a kapcsolatot.
        </h2>
        <form
          v-show="!success"
          action=""
          @submit.prevent="submit"
          class="form-container w-full"
          ref="form"
        >
          <div class="form-row">
            <div class="form-control">
              <input
                type="text"
                v-model="formData.name"
                name="name"
                id="offer-name"
                required="required"
                placeholder="Teljes név"
              />
            </div>
            <div class="form-error"></div>
          </div>
          <div class="form-row">
            <div class="form-control">
              <input
                type="email"
                v-model="formData.email"
                name="email"
                id="offer-email"
                required="required"
                placeholder="Email cím"
              />
            </div>
            <div class="form-error"></div>
          </div>
          <div class="form-row">
            <div class="form-control">
              <input
                type="tel"
                v-model="formData.phone"
                name="phone"
                pattern="^[0-9+-/]*$"
                id="offer-phone"
                required="required"
                placeholder="Telefon"
              />
            </div>
            <div class="form-error"></div>
          </div>
          <div class="form-row">
            <div class="form-control">
              <textarea
                class="bg-white w-full"
                v-model="formData.message"
                name="message"
                id="offer-message"
                required="required"
                placeholder="Üzenet"
                oninput='this.style.height = "";this.style.height = this.scrollHeight + "px"'
                @focus="resize"
                @keyup="resize"
                ref="textarea"
                rows="1"
              ></textarea>
            </div>
            <div class="form-error"></div>
          </div>
          <div class="form-row">
            <div class="form-control">
              <Button :disabled="isEmpty" class="blue fullwidth">Küldés</Button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import Button from "@/components/inputs/Button.vue";
import { mapState } from "vuex";

export default {
  name: "OfferModal",
  components: { Button },
  data() {
    return {
      opened: false,
      success: false,
      formData: {
        name: "",
        email: "",
        phone: "",
        message: "",
        officeId: null
      }
    };
  },
  computed: {
    isEmpty() {
      return (
        this.formData.name == "" ||
        this.formData.email == "" ||
        this.formData.phone == "" ||
        this.formData.message == ""
      );
    },

    ...mapState({
      highlighted: state => state.offices.highlighted
    })
  },
  watch: {
    "formData.name": {
      deep: true,
      handler(curr, prev) {
        if (
          this.formData.message === "" ||
          this.formData.message ===
            `Üdvözlöm, ${prev} vagyok és érdeklődni szeretnék az alábbi iroda / irodák felől.`
        ) {
          this.formData.message = `Üdvözlöm, ${curr} vagyok és érdeklődni szeretnék az alábbi iroda / irodák felől.`;
          this.resize();
        }
      }
    }
  },
  mounted() {
    this.resize();
  },
  methods: {
    resize() {
      const { textarea } = this.$refs;
      if (textarea) {
        textarea.style.height = textarea.scrollHeight + "px";
      }
    },
    open() {
      this.opened = true;
    },
    close() {
      this.opened = false;
    },
    submit() {
      this.formData.offices = this.highlighted.map(o => o.id);
      this.success = true;
      this.$store.dispatch("offices/askOffer", this.formData).then(response => {
        this.$store.commit("offices/deselectAll");
        setTimeout(() => {
          this.opened = false;
          this.success = false;
          this.formData = {
            name: "",
            email: "",
            phone: "",
            message: "",
            officeId: null
          };
        }, 3000);
      });
    }
  }
};
</script>

<style lang="scss">
.offer-modal {
  h2,
  p {
    color: #525252;
  }

  .layer-container {
    box-sizing: border-box;
    max-width: 550px;
    max-height: 90%;
    height: auto;
    padding: 16px;
    overflow: scroll;
  }

  .form-row .form-control {
    input:focus {
      box-shadow: none;
    }

    textarea {
      width: 100% !important;
      padding: 16px 20px 12px;
      background: white;
      overflow: hidden;
      font-size: 19px;
      font-family: "Lexend Exa", Arial;
      line-height: 22px;
      border-radius: 12px;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      border: 0;
      margin: 0;
      -webkit-box-shadow: 0 0 0 2px rgba(255, 255, 255, 0);
      box-shadow: 0 0 0 2px rgba(255, 255, 255, 0);
      outline: none;
      -webkit-appearance: none;
      -moz-appearance: none;
      appearance: none;
      -webkit-transition: outline 0.3s ease-in-out;
      transition: outline 0.3s ease-in-out;
    }
  }
}
</style>
